<template>
  <div
    v-show="isWrapperShow"
    @click.prevent
    :style="computedStyle"
    :class="[`drop-menu-item drop-menu-item-${position}`]"
  >
    <md-popup
      v-model="isPopupShow"
      :position="position"
      :transition="transitionName"
      @hide="onClose"
    >
      <div class="popup-body">
        <div class="filter" v-if="hasFilter">
          <md-input-item
            v-model.trim="filterKey"
            type="text"
            :placeholder="$t('exchange.filterPlaceholder')"
          >
            <div class="input-item-left row-center" slot="left">
              <md-icon name="search" size="lg" color="currentColor"></md-icon>
            </div>
          </md-input-item>
        </div>
        <div class="scroller">
          <md-scroll-view :scrolling-x="false" auto-reflow :touch-angle="70">
            <div class="cell-list">
              <div
                v-for="option in computedOptions"
                :key="option.value"
                :class="[
                  'cell-item',
                  'row-justify-center',
                  option.value === value ? 'active' : '',
                ]"
                @click="onItemClick(option)"
              >
                <slot :option="option" :selected="option.value == value">
                  <div class="cell-item-left">{{ option.label }}</div>
                  <div class="cell-item-right row-center">
                    <md-icon
                      name="right"
                      size="lg"
                      color="currentColor"
                      v-if="option.value == value"
                    ></md-icon>
                  </div>
                </slot>
              </div>
              <div class="empty row-center" v-if="computedOptions.length === 0">
                {{ $t('exchange.notFound') }}
              </div>
            </div>
          </md-scroll-view>
        </div>
      </div>
    </md-popup>
  </div>
</template>

<script>
import { Popup, Icon, InputItem, ScrollView } from 'mand-mobile';
export default {
  components: {
    [Popup.name]: Popup,
    [Icon.name]: Icon,
    [InputItem.name]: InputItem,
    [ScrollView.name]: ScrollView,
  },
  props: {
    position: {
      type: String,
      default: 'top',
    },
    value: {
      type: [String, Number],
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    options: {
      type: Array,
      default: () => [],
    },
    hasFilter: {
      type: Boolean,
      default: false,
    },
    getValue: {
      type: Function,
      default: obj => (obj && obj.label) || '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  model: {
    prop: 'value',
    event: 'change',
  },
  data() {
    return {
      isWrapperShow: false,
      isPopupShow: false,
      hasTransition: true,
      filterKey: '',
    };
  },
  inject: {
    rootDropMenu: {
      from: 'rootDropMenu',
      default() {
        return this.$parent;
      },
    },
  },
  watch: {
    selectedText() {
      this.rootDropMenu.$forceUpdate();
    },
  },
  computed: {
    selectedText() {
      const obj = this.options.find(item => item.value === this.value);
      return this.getValue(obj) || this.title;
    },
    transitionName() {
      if (!this.hasTransition) {
        return '';
      }
      switch (this.position) {
        case 'bottom':
          return 'md-slide-up';
        /* istanbul ignore next */
        case 'top':
          return 'md-slide-down';
        /* istanbul ignore next */
        case 'left':
          return 'md-slide-right';
        /* istanbul ignore next */
        case 'right':
          return 'md-slide-left';
        default:
          return 'md-fade'; // fade/fade-bounce/fade-slide/fade-zoom
      }
    },
    computedStyle() {
      const obj = {};
      if (this.position == 'top') {
        obj.top = `${this.rootDropMenu.offset.bottom}px`;
      } else if (this.position == 'bottom') {
        obj.bottom = `${window.innerHeight - this.rootDropMenu.offset.top}px`;
      }
      return obj;
    },
    computedOptions() {
      return this.options.filter(item => {
        if (this.filterKey) {
          return (
            item.value &&
            item.label.toLowerCase().indexOf(this.filterKey.toLowerCase()) > -1
          );
        }
        return true;
      });
    },
  },
  created() {
    this.rootDropMenu.$_addMenu(this);
  },
  destroyed() {
    this.rootDropMenu.$_removeMenu(this);
  },
  methods: {
    onClose() {
      this.isWrapperShow = false;
      this.filterKey = '';
      this.$emit('close');
    },
    toggle(show = !this.isPopupShow, options = {}) {
      if (this.disabled) return;
      if (show == this.isPopupShow) {
        return;
      }
      this.isPopupShow = show;
      this.hasTransition = !options.immediate;
      if (show) {
        this.isWrapperShow = true;
      }
    },
    onItemClick(option) {
      this.isPopupShow = false;
      if (option.value !== this.value) {
        this.$emit('hook:updateValue', option.value);
        this.$emit('change', option.value);
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
.drop-menu-item {
  position: fixed;
  left: 0;
  width: 100vw;
  z-index: 100;
  overflow: hidden;

  &.drop-menu-item-top {
    bottom: 0;

    .popup-body {
      padding-bottom: 6.4vw;
      border-radius: 0 0 3.2vw 3.2vw;
    }
  }

  &.drop-menu-item-bottom {
    top: 0;

    .popup-body {
      padding-top: 6.4vw;
      border-radius: 3.2vw 3.2vw 0 0;
    }
  }
}

.md-popup {
  position: absolute;
  z-index: 101;
}

.empty {
  min-height: 40vw;
  color: #84969C;
}

.popup-body {
  background: #fff;
}

.filter {
  padding: 4.8vw;

  .md-input-item {
    border: 0.27vw solid #eaf1f3;
    padding: 0 2.67vw;
    border-radius: 2.67vw;
    background: #f8fbfc;

    & >>> {
      .md-field-item-content:before {
        content: none;
      }

      .md-field-item-left {
        margin-right: 5.33vw;
        color: #B4C2C7;
      }
    }
  }
}

.scroller {
  box-sizing: border-box;
  width: 100%;
  height: 100vw;
  overflow: hidden auto;
  background: #fff;
}

.cell-item {
  position: relative;
  margin: 0 6.4vw;
  height: 12.8vw;
  font-size: 4vw;
  hairline(bottom);
  background: #fff;

  &.active {
    color: color-primary;
  }

  .cell-item-right {
    min-width: 6.4vw;
  }
}
</style>
